import {
  FormControl, Input, SystemStyleObject, Text, TextProps, useColorModeValue, FormControlProps,
  InputProps,
} from "@chakra-ui/react";
import { get } from "lodash";
import ErrorText from "components/FormElements/ErrorText";

export const NAME_FIELD = {
  type: "text",
  label: "Title",
  name: "title",
};

function nameStyles(color: string) {
  return ({
    color,
    fontSize: "18px",
    fontWeight: "700",
  });
}

interface CommonProps {
  form: any;
  disabled?: boolean;
  sx?: SystemStyleObject;
  inputProps?: InputProps;
  formControlProps?: FormControlProps;
}

type NameFieldProps = CommonProps;

export default function NameField({
  form,
  disabled = false,
  sx = {},
  inputProps = {},
  formControlProps = {},
  ...props
}: NameFieldProps) {
  const headerColor = useColorModeValue("content.primary", "var(--chakra-colors-whiteAlpha-900)");
  const {
    formState: { errors },
    register,
  } = form;
  const error = get(errors, "name");

  return (
    <FormControl variant="unstyled" id="name" isInvalid={!!error} isDisabled={disabled} {...formControlProps}>
      <Input
        {...NAME_FIELD}
        errors={errors}
        label={null}
        disabled={disabled}
        variant="unstyled"
        height="32px !important"
        paddingTop="0 !important"
        paddingX="8px !important"
        placeholder="+ Add title..."
        borderRadius="md"
        _focus={{ bg: "white", boxShadow: "none" }}
        sx={{ ...nameStyles(headerColor), ...sx }}
        {...register("name")}
        {...inputProps}
      />
      <ErrorText error={error} />
    </FormControl>
  );
}

interface ShowNameProps extends TextProps {
  name: string
}

export function ShowName({ name, ...props }: ShowNameProps) {
  const headerColor = useColorModeValue("content.primary", "var(--chakra-colors-whiteAlpha-900)");
  return (
    <Text
      sx={nameStyles(headerColor)}
      {...props}
    >
      {name}
    </Text>
  );
}
